// extracted by mini-css-extract-plugin
module.exports = {"templateStyle":"XKgti69RJTnqfJjXB_B2s"};